import React, { useEffect, useState } from "react";
import styles from "./member.module.scss";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { avatarCreater, searchHighlight, userStatusColor } from "../../../../base/callService/common";
import store from "../../../../context/store/store";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import teamIcn from "../../../../styles/images/teamimg.svg";
import _, { filter } from "lodash";

export default function MemberLists(searchText: string,allContacts:Array<any>,isExt?:any) {
  //const [isModalVisible, setIsModalVisible] = useState(false);
  // const [groupCallbtn, setGroupCallbtn] = useState(false)
  // console.log("groupCallbtn---",groupCallbtn)
  const { workContacts, favContacts, teamContacs } = store.getState().contactReducer;
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  let favList: Array<any> = favContacts;
  let teamCont: any = teamContacs;
  let companyContacts: any = workContacts;
 //Left top bar DropDown Call option
  const GroupCall = planBased.find((item: any) => item.featureid === 49);
  const groupCallbtn = !(GroupCall && GroupCall.value1 === "Yes");

  if(groupCallbtn)
  {
    const filtered = allContacts.filter((contact:any) => !contact.team_id)
    allContacts = filtered;
  }
  let len = Math.round((allContacts?.length / 8));
  len = allContacts.length ===1 ? 1:allContacts?.length ;
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

    // let favorites =  store.getState().contactReducer.;
  // const showModal = () => {
  //   setIsModalVisible(true);
  // };


  // const handleCancel = () => {
  //   setIsModalVisible(false);
  // };

  //let contactList: any = contactSearchData(searchText) || [];
 
  return (
    <>
      {searchText===''?<>

        {favList?.length > 0 && <>
          <div className="titlesdrop">Favourite / Frequently Contacted</div>

          {favList?.map((contactName: any, index: any) => {
            return <option key={index} value={isExt?contactName.ext:contactName.sip_login_id}>
              <div className="dropdowndesign">
                <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')}/></>) :
                      (<>
                        <span>{contactName?.first_name?.charAt(0).toUpperCase() + contactName?.last_name?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')} />
                      </>)
                  } />
                <div className="names">{contactName.caller_id}</div>
                <div className="ext">{contactName.ext }</div>
              </div>
            </option>;

          })}
        </>}
      

        { planBased?.find((item:any) => item.featureid === 49)?.value1 === "Yes" &&
        teamCont?.length>0&&
           <> <div className="titlesdrop">Groups</div>
          {teamCont?.map((contactName: any, index: any) => {
             
            // let avatarFinder = avatarCreater(contactName);
            return <option  key={contactName?.team_id} value={contactName?.team_id_prefix?.concat(contactName?.team_id)}>
              <div className="dropdowndesign">
                <URAvatarGroup className={`lefts size20 two colorBG${random_color[index]} ${(contactName.profile_image_url !== null && contactName.profile_image_url !== "")?'avatarWithImg':'' }`}

                  profileInfo={
                    (contactName.profile_image_url !== null && contactName.profile_image_url !== "") ?
                      <img src={contactName.profile_image_url} alt="" />
                      :
                      <>
                       <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>
                        {/* {avatarFinder.teamMembers?.length === 1 &&
                           <span>{contactName?.team_name?.charAt(0).toUpperCase()}</span> }
                        {avatarFinder.teamMembers?.length > 1 &&
                            <> <span>{avatarFinder?.teamMembers[0]?.charAt(0).toUpperCase()}</span>
                              <span>{avatarFinder?.teamMembers[1]?.charAt(0).toUpperCase()}</span></>}
                        {avatarFinder.teamMembers?.length > 2 &&
                          <span>{avatarFinder?.teamMembers[2]?.charAt(0).toUpperCase()}</span>}
                        {avatarFinder.teamMembers?.length > 3 &&
                          <span>{avatarFinder?.teamMembers[3]?.charAt(0).toUpperCase()}</span>} */}
                      </>
                  } />
                <div className="names">{contactName.team_name? contactName.team_name: ""}</div>
                
                <div className="ext">{contactName.ext }</div>
              </div>
            </option>;

          })
          }
        </>
        }
       
 
          {/* <><p className='titlesdrop'>{list?.group}</p>      */}
            
            {companyContacts?.map((contactName: any, index: any) => {
              return <option key={contactName?.ext || contactName?.sip_login_id} value={isExt?contactName?.ext:contactName?.sip_login_id}>

            {
              ((companyContacts[index - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                <div className="titlesdrop titlesdropSelected">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
              }
                <div className="dropdowndesign">
               
                  <URAvatarGroup className={`lefts size20 colorBG${random_color[index]} ${(contactName?.ImageURL !== null && contactName?.ImageURL !== "")?'avatarWithImg':'' }`}
                    profileInfo={
                      (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                        (<>
                          <img src={contactName.ImageURL} alt="" />
                          <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                        (<>
                          <span>{contactName?.first_name?.charAt(0).toUpperCase() + contactName?.last_name?.charAt(0).toUpperCase()} </span>
                          <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                        </>)
                    } />
        
                  <div className="names">{contactName.caller_id}</div>
              
                  <div className="ext">{contactName.ext}</div>
                </div>
              </option>;
    
            })}
              </>         
        :
        <>
          {allContacts?.map((contactName: any, index: any) => {
            let highlighted: any = searchHighlight(contactName, searchText);
            let avatarFinder = avatarCreater(contactName);
            return <option key={contactName?.sip_login_id || contactName?.team_id} value={(contactName?.sip_login_id)?(isExt?contactName?.ext:contactName?.sip_login_id) :
              (contactName.team_id_prefix.concat(contactName.team_id))}>
              <div className="dropdowndesign">
              <URAvatarGroup className={`lefts size22 colorBG${random_color[index]} ${(contactName?.ImageURL !== null && contactName?.ImageURL !== '' && contactName?.profile_image_url !== null && contactName?.profile_image_url !== "") ? 'avatarWithImg' : ""}`} profileInfo={<>
                              {(contactName.ImageURL || contactName.profile_image_url) ?
                                <img src={contactName.caller_id ? contactName?.ImageURL : contactName.team_name ? contactName?.profile_image_url : ""} alt="" /> :
                                <span>{contactName?.caller_id ? contactName?.first_name?.charAt(0).toUpperCase() + contactName?.last_name?.charAt(0).toUpperCase() : <span className="teamImgSearch"><img src={teamIcn} alt="team icon" /></span>}</span>}
                            </>} />

                <div className="names">{ (highlighted?.middleMsg !== "") ?(<>{ highlighted?.firstMsg}
                  <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                  {highlighted?.lastMsg}</>) :

                  (<>{contactName?.caller_id?contactName?.caller_id:contactName?.team_name}</>)}</div>

                { contactName.ext&&<div className="ext">{contactName.ext }</div>}
              </div>
            </option>;
    
          })}
        </>
      
      }
    </>
    
  );
};
